import { formatHours, isSameDay, toDateKey } from "../../utils/date";

// Labels per status. Colours live in AttendanceView.module.css
// (one class per status key).
export const STATUS_LABELS = {
  present: "Present",
  late: "Late",
  absent: "Absent",
  halfDay: "Half day",
  leave: "On Leave",
  weekend: "Weekend",
  upcoming: "Upcoming",
};

const API_STATUS_MAP = {
  ON_LEAVE: "leave",
  LATE: "late",
  ABSENT: "absent",
  PRESENT: "present",
  HALF_DAY: "halfDay",
};

export const getStatusForDate = (date, recordsByDate) => {
  const record = recordsByDate[toDateKey(date)];
  if (record) return API_STATUS_MAP[record.status] ?? "present";

  const today = new Date();
  const isWeekend = date.getDay() === 0 || date.getDay() === 6;
  const isFuture = date > today && !isSameDay(date, today);

  if (isWeekend) return "weekend";
  if (isFuture) return "upcoming";
  return "absent";
};

// true / false / null (null = branch has no location set).
export const isOutsideBranch = (record) =>
  record?.checkInOutsideBranch === true ||
  record?.checkOutOutsideBranch === true;

export const formatRecordHours = (record) =>
  typeof record?.workHours === "number" && record.workHours > 0
    ? formatHours(record.workHours)
    : "--";
